<template>
  <div
    class="numeric-pad"
    :class="{
      'numeric-pad--open': status === 'open',
      'numeric-pad--with-button': renderButton
    }"
  >
    <div class="numeric-pad__row">
      <div @click="pressed($event, 1)" class="numeric-pad__box w-1/3">1</div>
      <div @click="pressed($event, 2)" class="numeric-pad__box w-1/3">2</div>
      <div @click="pressed($event, 3)" class="numeric-pad__box w-1/3">3</div>
    </div>
    <div class="numeric-pad__row">
      <div @click="pressed($event, 4)" class="numeric-pad__box w-1/3">4</div>
      <div @click="pressed($event, 5)" class="numeric-pad__box w-1/3">5</div>
      <div @click="pressed($event, 6)" class="numeric-pad__box w-1/3">6</div>
    </div>
    <div class="numeric-pad__row">
      <div @click="pressed($event, 7)" class="numeric-pad__box w-1/3">7</div>
      <div @click="pressed($event, 8)" class="numeric-pad__box w-1/3">8</div>
      <div @click="pressed($event, 9)" class="numeric-pad__box w-1/3">9</div>
    </div>
    <div class="numeric-pad__row">
      <div class="numeric-pad__box w-1/3"></div>
      <div @click="pressed($event, 0)" class="numeric-pad__box w-1/3">0</div>
      <div
        @click="pressed($event, 'X')"
        class="numeric-pad__box w-1/3 numeric-pad__delete"
      >
        <div class="icon icon-delete icon--l"></div>
      </div>
    </div>
    <div v-if="renderButton" class="numeric-pad__row px-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {},
  props: ["renderButton"],

  data() {
    return {
      status: "closed"
    };
  },
  mounted() {
    this.$root.$on("openNumericPad", this.openNumericPad);
    this.$root.$on("closeNumericPad", this.closeNumericPad);
  },
  methods: {
    openNumericPad() {
      this.status = "open";
      this.$root.$emit("openedNumericPad");
    },
    closeNumericPad() {
      this.status = "closed";
      this.$root.$emit("closedNumericPad");
    },
    pressed(event, key) {
      event.target.classList.add("pressed");

      setTimeout(() => {
        event.target.classList.remove("pressed");
      }, 100);

      this.$root.$emit("onNumericPadKeyPressed", key);
    },
    back() {
      //service.send("continue");
      this.$root.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="less">
.numeric-pad {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  background: white;
  left: 0;
  width: 100%;
  transition: all 0.3s;
  height: 320px;
  bottom: -320px;
  padding: 20px 0px;
  -webkit-box-shadow: 0px -2px 5px 0px #818181bf;
  -moz-box-shadow: 0px -2px 5px 0px #818181bf;
  box-shadow: 0px -2px 5px 0px #818181bf;

  &--with-button {
    height: 50vh;
    bottom: -1000px;
  }

  &--open {
    bottom: 0;
  }

  &__row {
    text-align: center;
    display: flex;
    align-items: center;
  }
  &__box {
    font-size: 30px;
    cursor: pointer;

    &.pressed {
      font-weight: bold;
    }
  }
  &__delete {
    padding-right: 10px;
    .icon {
      background-position-x: center;
      margin: 0 auto;
    }
  }
}
</style>
